import * as yup from "yup";

export const interestedSellerInquiryFormSchema = yup.object().shape({
  name: yup.string().required("This field is required."),
  email: yup.string().required("This field is required."),
  phone_number: yup.string().required("This field is required."),
  contact_preferences: yup
    .object()
    .shape({
      email: yup.boolean(),
      call: yup.boolean(),
      text: yup.boolean()
    })
    .test("hasOneChecked", "This field is required.", contactPreferences =>
      Object.values(contactPreferences).some(preference => preference)
    )
});
